<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <span class="font" style="display: flex; align-items: center"
        >资讯分类
        <div style="font-size: 12px; font-weight: 500; margin-left: 24px">
          <el-alert
            title="备注：存在子级分类/文章的资讯分类不可删除。"
            show-icon
            :closable="false"
            type="warning"
          >
          </el-alert>
        </div>
      </span>
      <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left">
        <!-- <el-form-item prop="name">
          <el-input v-model="formTool.name"
                    placeholder="请输入商品名称"
                    clearable
                    size="small" />
        </el-form-item>
        <el-form-item prop="approvalNumber">
          <el-input v-model="formTool.approvalNumber"
                    placeholder="请输入批准文号"
                    clearable
                    size="small" />
        </el-form-item> -->
        <el-form-item>
          <el-button size="small" type="primary" @click="add()">添加资讯分类</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button size="small"
                     @click="reset()">重置</el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <div class="center" style="position: relative">
      <el-table
        ref="informationTable"
        :data="tableData"
        highlight-current-row
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        lazy
        :load="load"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column prop="classifyName" label="资讯分类名称" width="220">
        </el-table-column>
        <el-table-column prop="articleCount" label="文章数" width="180">
        </el-table-column>
        <el-table-column prop="operationAuthority" label="是否启用">
          <template slot-scope="scope">
            {{
              scope.row.operationAuthority
                ? scope.row.operationAuthority.slice(
                    0,
                    scope.row.operationAuthority.length
                  )
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link
              :underline="false"
              type="primary"
              @click="clickSearch('edit', scope.row)"
            >
              编辑
            </el-link>
            <el-link
              :underline="false"
              style="margin-left: 16px"
              type="primary"
              @click="deleteHandle(scope.row)"
            >
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="el-page"
         style="padding-right: 24px !important;">
      <Pagination :total="page.total"
                  :page.sync="page.current"
                  :limit.sync="page.size"
                  :page-sizes="page.pageSizes"
                  @pagination="pageChange" />
    </div> -->
  </div>
</template>

<script>
import {
  getInformationClassify,
  deleteClassify,
  queryInformationClassifyByParentIdByWCB
} from "@/api/message/InformationClassification";
import Pagination from "@/components/Pagination";

export default {
  name: "WareProduct",
  components: { Pagination },
  data() {
    return {
      selectRow: {},
      formTool: {},
      tableData: [],
      page: {
        total: 0,
        current: 1,
        size: 20,
        pageSizes: [10, 20, 30, 50],
      },
      maps: new Map(),
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getInformationClassifyTree(0);
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    // 点击某一行
    rowClick(row) {
      // this.clickSearch('clickrow', row)
      this.selectRow = row;
    },
    // 编辑
    editHandle(row) {
      // this.$router.push({
      //   path: '/productManage/wareProduct-editSku',
      //   query: row
      // })
      console.log(row);
    },
    // 删除
    deleteHandle(row) {
      this.$confirm("请确认是否删除", "删除分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteClassify(row.id).then((res) => {
            if (res) {
              this.$message.success("删除成功");
              if (row.parentId && row.parentId != 0) {
                const { tree, treeNode, resolve } = this.maps.get(row.parentId); // 根据父级id取出对应的节点数据
                this.$set(
                  this.$refs.informationTable.store.states.lazyTreeNodeMap,
                  row.parentId,
                  []
                );
                this.load(tree, treeNode, resolve);
              } else {
                this.getInformationClassifyTree(0);
              }
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {});
    },
    // 切换分页
    pageChange() {
      this.getInformationClassifyTree();
    },

    getInformationClassifyTree(id) {
      // if (current) { // 搜索条件改变从第一页开始查询
      //   this.page.current = current
      // }
      // const params = {
      //   current: this.page.current,
      //   size: this.page.size
      // }
      queryInformationClassifyByParentIdByWCB(id).then((res) => {
        if (res) {
          this.tableData = res;
          // this.page.total = res.data.total
        } else {
          this.tableData = [];
          // this.page.total = 0
        }
      });
    },
    add() {
      // if (!this.selectRow) {
      this.clickSearch("add");
      // } else {
      //   this.clickSearch('clickrow')
      // }
    },
    // 添加资讯分类
    clickSearch(type, row) {
      if (type == "add") {
        this.$router.push({
          path: "/operationCenter/message-editClassification",
          query: {
            type: "add",
          },
        });
      } else if (type == "edit") {
        this.$router.push({
          path: "/operationCenter/message-editClassification",
          query: {
            type: "edit",
            classifyName: row.classifyName,
            newSort: row.sort,
            operationAuthority: row.operationAuthority,
            id: row.id,
            nodeInfo: row.nodeInfo,
            parentId: row.parentId,
          },
        });
      } else {
        this.$router.push({
          path: "/operationCenter/message-editClassification",
          query: {
            type: "clickrow",
            nodeInfo: this.selectRow.nodeInfo,
          },
        });
      }
    },
    load(tree, treeNode, resolve) {
      this.maps.set(tree.id, { tree, treeNode, resolve });
      queryInformationClassifyByParentIdByWCB(tree.id).then((res) => {
        if (res) {
          resolve(res);
        } else {
          resolve([]);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.classification {
  padding: 0px;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
  .el-form-item {
    margin: 0px 0px 0px 8px !important;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 0 24px;
  height: calc(100% - 131px);
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shangjia {
    position: absolute;
    z-index: 2;
    bottom: -45px;
  }
}
</style>
